import React, { useState, useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { HighlightOffRounded } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import request from '../../services/Request';
import KeyBoard from '../items/keyboard';
import { clearPromo, submitPromo } from '../../services/promo';
import { Button } from '@material-ui/core';

export default function PromoModal(props) {
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  const [showKeyboard, setShowKeyboard] = useState(false);

  const [isFound, setIsFound] = useState(false);

  const { t } = useTranslation();
  const keyboard = useRef();
  const { show, onHide, products, setShow, clientUser, total, cart, setClientUser } = props;

  useEffect(() => {
    if (show) {
      console.log('total', total);
      console.log('clientuSER', clientUser);
    }
  }, [show]);

  const applyDiscountCard = (index) => {
    let disocuntCard = clientUser?.clientPromo[index];
    clientUser.discount = disocuntCard;
    clientUser.discount_id = disocuntCard._id;
    setClientUser({ ...clientUser });
  };

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };
  // const handleClose = () => {
  //   setShowKeyboard(false);
  // };
  // const handleShow = () => {
  //   setShowKeyboard(true);
  // };

  useEffect(() => {
    setTimeout(() => {
      setShowKeyboard(show);
    }, 400);
    setInput('');
    setError('');
  }, [show]);

  const clearPromotion = () => {
    setIsFound(false);
    setError('');
    clearPromo(props.cart, props.changePrice, products);
  };

  const onPromoSubmit = async (e) => {
    clearPromotion();
    // await request({
    //   method: 'post',
    //   url: '',
    //   data: {
    //     machine: machineID,
    //     code: '',
    //   },
    // }).then((res) => {});

    const promoData = JSON.parse(localStorage.getItem('promo'));
    let promoCode = '';
    let isFound = false;
    if (promoData) {
      isFound = await submitPromo(promoData, input, props.cart, props.changePrice, request);

      console.log('isFound', isFound);
      if (!isFound) {
        // logger(1, 'A invalid promote code has been entered');
        setError(t('The code is not valid'));
      } else {
        setIsFound(true);
        setShow(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body className="ui-bg-color promo-modal">
        <HighlightOffRounded
          className="close_circle_icon"
          style={{ fontSize: '40px', marginTop: '0px' }}
          onClick={() => {
            props.onHide();
          }}
        />
        <div
          id="close_promo_modal"
          onClick={() => {
            props.onHide();
          }}
        ></div>
        <Container>
          <div className="d-flex flex-column align-items-center justify-content-center mt-4 pb-4">
            <div className="promo-text mb-5">{t(`Scan or enter your promotion code`)}</div>
            <input
              type="search"
              placeholder={t(`Discount Code`)}
              value={input}
              // onClick={handleShow}
              onChange={onChangeInput}
              aria-label="Search"
              className="promo-input"
            />
            {showKeyboard && (
              <KeyBoard
                show={showKeyboard}
                setShow={setShowKeyboard}
                handleClick={onPromoSubmit}
                send={true}
                // handleClose={onHide()}
                input={input}
                setInput={setInput}
                keyboard={keyboard}
              />
            )}
            {error && <div className="cart-checkout-error mt-5">{error}</div>}
            <div className="d-flex flex-column align-items-center justify-content-center">
              {!isFound &&
                clientUser?.clientPromo?.length > 0 &&
                clientUser?.clientPromo?.map((promo, index) => {
                  if (promo.amount < total)
                    return (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-center mt-4  "
                        style={{
                          flexDirection: 'row !important',
                        }}
                      >
                        <div className="promo-text mr-2" key={index}>
                          {`Discount Card: $${promo.amount} off`}
                        </div>
                        <div>
                          <Button
                            className="promo-button ml-2"
                            color="primary"
                            variant="contained"
                            disabled={promo?._id === clientUser?.discount?._id}
                            onClick={() => applyDiscountCard(index)}
                          >
                            {promo?._id === clientUser?.discount?._id ? t(`Applied`) : t(`Apply`)}
                          </Button>
                        </div>
                        {/* <button
                            className="promo-button"
                            onClick={() => {
                              clearPromotion();
                              applyDiscountCard(index);
                            }}
                          >
                            {t(`Apply`)}
                          </button> */}
                      </div>
                    );
                })}
            </div>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
